module.exports = __webpack_public_path__ + "static/img/pos_pay_info.1aabbfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_pay_info.png
// module id = QK4B
// module chunks = 8